<template>
  <el-dialog
    title="选择标的物"
    :visible.sync="visible"
    width="900px"
    custom-class="lease-ylw-dialog"
    :close-on-click-modal="false"
    append-to-body
    @open="onOpen"
  >
    <div class="selector-toolbar">
      <span class="selector-label">标的物编号</span>
      <el-input
        v-model="propertyCode"
        size="small"
        clearable
        placeholder="请输入"
        class="search-input"
        @keyup.enter.native="loadData(1)"
      />
      <el-button size="small" class="selector-query-btn" @click="loadData(1)">查询</el-button>
      <el-button size="small" class="selector-reset-btn" @click="resetSearch">重置</el-button>
    </div>
    <div class="selector-table-wrap">
      <el-table
        ref="table"
        :data="list"
        size="medium"
        border
        max-height="420"
        row-key="id"
        @selection-change="onSelectionChange"
      >
        <i slot="empty" style="font-style:normal">暂无可用标的物</i>
        <el-table-column type="selection" width="50" align="center" :reserve-selection="true" />
        <el-table-column label="序号" type="index" align="center" width="60" />
        <el-table-column prop="propertyCode" label="标的物编号" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column label="标的物类型" align="center" width="120">
          <template slot-scope="scope">{{ typeLabel(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="area" label="面积(亩)" align="center" width="100" />
        <el-table-column prop="address" label="地址" align="center" min-width="160" show-overflow-tooltip />
        <el-table-column prop="propertyRent" label="租金(元)" align="center" width="120" />
      </el-table>
    </div>
    <div class="selector-pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handlePageChange"
        :current-page="pageInfo.pageNumber"
        :page-size="pageInfo.pageSize"
        :total="pageInfo.totalPages"
      />
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定（已选{{ selectedRows.length }}）</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  pageContractAvailableProperty,
  pageAvailableProperty,
  leaseRequestError
} from "@/service/fishPondLease";
import { PropertyType, enumLabel } from "@/service/fishPondLeaseEnums";

export default {
  name: "PropertySelector",
  props: {
    /** 使用合同侧可签约接口；false 时用标的物 availableProperty */
    useContractApi: { type: Boolean, default: true },
    /** 已选 propertyId，打开时排除或仅作提示 */
    excludeIds: { type: Array, default: function() { return []; } }
  },
  data() {
    return {
      visible: false,
      propertyCode: "",
      list: [],
      selectedRows: [],
      pageInfo: {
        pageNumber: 1,
        totalPages: 0,
        pageFunc: this.loadData,
        pageSize: 10
      }
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    typeLabel(row) {
      var typeTxt = enumLabel("propertyType", row.type);
      if (
        Number(row.type) === PropertyType.FishPond &&
        row.subType != null &&
        row.subType !== ""
      ) {
        return typeTxt + " - " + enumLabel("propertySubType", row.subType);
      }
      return typeTxt;
    },
    onOpen() {
      this.propertyCode = "";
      this.selectedRows = [];
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.clearSelection();
        }
        this.loadData(1);
      });
    },
    loadData(pageNum) {
      const pageIndex = pageNum || this.pageInfo.pageNumber || 1;
      this.pageInfo.pageNumber = pageIndex;
      const params = {
        pageIndex: pageIndex,
        pageSize: this.pageInfo.pageSize,
        propertyCode: this.propertyCode || undefined
      };
      const req = this.useContractApi
        ? pageContractAvailableProperty(params)
        : pageAvailableProperty(params);
      req
        .then(res => {
          const data = (res && res.data) || {};
          const raw = data.list || [];
          const exclude = this.excludeIds || [];
          this.list = raw.filter(function(row) {
            return exclude.indexOf(row.id) === -1 && exclude.indexOf(String(row.id)) === -1;
          });
          this.pageInfo.totalPages = data.total || 0;
        })
        .catch(err => {
          this.$message.error(leaseRequestError(err));
        });
    },
    resetSearch() {
      this.propertyCode = "";
      this.loadData(1);
    },
    handlePageChange(val) {
      this.loadData(val);
    },
    onSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    confirm() {
      if (!this.selectedRows.length) {
        this.$message.warning("请至少选择一个标的物");
        return;
      }
      const mapped = this.selectedRows.map(function(row) {
        return {
          propertyId: row.id,
          propertyCode: row.propertyCode,
          type: row.type,
          subType: row.subType,
          area: row.area,
          address: row.address,
          rentAmount: row.propertyRent
        };
      });
      this.$emit("confirm", mapped);
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.selector-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.selector-toolbar .selector-label {
  margin-right: 8px;
  color: #606266;
  white-space: nowrap;
}
.selector-toolbar .search-input {
  width: 240px;
  margin-right: 10px;
}
/* 查询按钮：对齐渔管理列表页蓝色 */
.selector-toolbar .selector-query-btn {
  width: 80px;
  height: 34px;
  font-size: 14px;
  margin-right: 6px;
  border: 0;
  background: #3389ff;
  border-radius: 4px;
  border-color: #3389ff;
  color: #fff;
}
.selector-toolbar .selector-query-btn:hover,
.selector-toolbar .selector-query-btn:focus {
  color: #fff;
  border-color: #3389ff;
  background-color: #3389ff;
}
.selector-toolbar .selector-reset-btn {
  width: 80px;
  height: 34px;
  font-size: 14px;
}
/* 表格底部线（max-height 下数据少时底部边框缺失） */
.selector-table-wrap {
  border: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
.selector-table-wrap >>> .el-table {
  border-right: 0;
  border-bottom: 0;
}
.selector-table-wrap >>> .el-table::before {
  display: none;
}
.selector-table-wrap >>> .el-table::after {
  display: none;
}
/* 分页居中，避免右溢出 */
.selector-pagination {
  display: flex;
  justify-content: center;
  padding: 16px 0 4px;
}
</style>
